import React, { useEffect, useState } from "react";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface InteractionsTotalMetricState {
  data: any | number;
  title: string;
  byType?: boolean;
  type?: string;
  readOnly?: boolean;
  active?: boolean;
  onHandleClick?: any;
}

// 3 options:
// by Type = false && type = undefined -> all interactions
// by Type = true && type = undefined -> interactions by all types
// by Type = false && type = "some type" -> interactions by specific type
export const InteractionsTotalMetric = ({
  data,
  title,
  byType = false,
  type,
  readOnly = true,
  active,
  onHandleClick,
}: InteractionsTotalMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [current, setCurrent] = useState<number | null>();
  const [currentTitle, setCurrentTitle] = useState<string>(title ?? "");
  const [currentTypes, setCurrentTypes] = useState<any[]>([]);
  const [selectedType, setSelectedType] = useState<string | undefined>(type);

  useEffect(() => {
    if (data) {
      const { notes } = data;
      //all
      if (!byType && !type) {
        setCurrentTitle(title);
        if (!notes) {
          //type count
          setCurrent(data);
        } else {
          setCurrent(notes?.total || 0);
        }
        setIsLoading(false);
        return;
      }
      if (byType) {
        let noteTypes = notes.note_type_counts || [];
        const filteredNoteTypes = noteTypes?.filter((t: any) => t?.type !== "system");

        const noteTypeExists = filteredNoteTypes.find((nt: any) => nt.name === selectedType);
        var currentSelected = "";
        if (noteTypeExists) {
          currentSelected = noteTypeExists?.name;
          setSelectedType(currentSelected);
          setCurrentTitle(currentSelected);
        } else {
          currentSelected = filteredNoteTypes[0]?.name;

          setSelectedType(currentSelected);
          setCurrentTitle(currentSelected);
        }
        setCurrentTypes(filteredNoteTypes);
        setCurrent(filteredNoteTypes.filter((note: any) => note.name === currentSelected).count || 0);
        setIsLoading(false);
        return;
      }
    }
    setIsLoading(false);
  }, [data]);

  if (readOnly) {
    return (
      <SingleCardMetric
        title={currentTitle ? currentTitle : "Interactions"}
        total={current}
        isLoading={isLoading}
        types={currentTypes}
        selectedType={selectedType}
        onSelectType={setSelectedType}
      />
    );
  } else {
    return (
      <SingleCardMetric
        title={currentTitle}
        total={current}
        isLoading={isLoading}
        types={currentTypes}
        selectedType={selectedType}
        onSelectType={setSelectedType}
        onHandleClick={onHandleClick}
        cursor={true}
        active={active}
      />
    );
  }
};
